module.exports = __webpack_public_path__ + "img/mark-group.4a07c44d.png";